import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const QuizService = {
  getList: async () => {
    const response = await apiService.get("/quizquestions");
    console.log(response);
    return response.data;
  },
  getLogs: async ({
    pageNumber = 1,
    pageSize = 10,
    searchText,
    fromDate,
    toDate,
  }) => {
    const params = new URLSearchParams({
      ...(searchText && { searchText }),
      ...(fromDate && { fromDate }),
      ...(toDate && { toDate }),
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(
      `/quizquestions/get-logs?${params.toString()}`
    );
    console.log(response);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post("/quizquestions", data);
    return response.data;
  },

  update: async (updatedData) => {
    const response = await apiService.put(`/quizquestions`, updatedData);
    return response.data;
  },

  getbySlug: async (slug) => {
    const response = await apiService.get(`/quizquestions/${slug}`);

    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/quizquestions/${id}`);
    console.log("called", response);
    return response.data;
  },
  getLogDetail: async (id) => {
    const response = await apiService.get(`/quizquestions/log-detail/${id}`);

    return response.data;
  },
};
export default QuizService;
